import React from "react";
import DonutChart from "./Charts";
import { Box, Typography } from "@mui/material";
import * as styles from "../styles/Portfolios.js";

const Portfolios = () => {
  return (
    <Box sx={styles.containerStyle}>
      <Typography variant="h3" sx={styles.perfilStyle}>
        Perfil Conservador
      </Typography>
      <Box sx={styles.boxPerfilStyle}>
        <Box sx={styles.boxPerfiles}>
          <Typography sx={styles.textStyle}>{styles.conservador1}</Typography>
          <br></br>
          <Typography sx={styles.textStyle2}>{styles.conservador2}</Typography>
          <br></br>
          <Typography sx={styles.textStyle2}>{styles.conservador3}</Typography>
        </Box>
        <DonutChart profile={"Conservador"} />
      </Box>
      <Typography variant="h3" sx={styles.perfilStyle}>
        Perfil Moderado
      </Typography>
      <Box sx={styles.boxPerfilStyle}>
        <Box sx={styles.boxPerfiles}>
          <Typography sx={styles.textStyle}>{styles.moderado1}</Typography>
          <br></br>
          <Typography sx={styles.textStyle2}>{styles.moderado2}</Typography>
          <br></br>
          <Typography sx={styles.textStyle2}>{styles.moderado3}</Typography>
        </Box>
        <DonutChart profile={"Moderado"} />
      </Box>
      <Typography variant="h3" sx={styles.perfilStyle}>
        Perfil Arriesgado
      </Typography>
      <Box sx={styles.boxPerfilStyle}>
        <Box sx={styles.boxPerfiles}>
          <Typography sx={styles.textStyle}>{styles.arriesgado1}</Typography>
          <br></br>
          <Typography sx={styles.textStyle2}>{styles.arriesgado2}</Typography>
          <br></br>
          <Typography sx={styles.textStyle2} marginBottom={10}>
            {styles.arriesgado3}
          </Typography>
        </Box>
        <DonutChart profile={"Arriesgado"} />
      </Box>
    </Box>
  );
};

export default Portfolios;
